import Undo from 'undo.js';

import { SketchFeatureProperty } from 'cadenza/map/classic-sketch-layer/sketch-feature-property';
import { modelStyleToOpenLayersStyle } from 'cadenza/map/classic-sketch-layer/sketch-style';

export class ChangeFeatureCommand extends Undo.Command {

  constructor (features) {
    super();
    this.features = features;

    this._oldState = features.map(feature => {
      const styleItem = feature.get(SketchFeatureProperty.OLD_STYLE_ITEM) || feature.get(SketchFeatureProperty.STYLE_ITEM);
      const geometry = feature.get(SketchFeatureProperty.OLD_GEOMETRY) || feature.getGeometry();
      return {
        feature,
        style: modelStyleToOpenLayersStyle(styleItem),
        geometry: geometry.clone()
      };
    });

    this._newState = features.map(feature => ({
      feature,
      style: modelStyleToOpenLayersStyle(feature.get(SketchFeatureProperty.STYLE_ITEM)),
      geometry: feature.getGeometry().clone()
    }));
  }

  execute () {
    // do nothing
  }

  redo () {
    this.setGeometryAndAttributes(this._newState);
  }

  undo () {
    this.setGeometryAndAttributes(this._oldState);
  }

  setGeometryAndAttributes (featuresState) {
    featuresState.forEach(state => {
      state.feature.setGeometry(state.geometry);
      state.feature.setStyle(state.style);
    });
  }

}
